import { api, actuator } from '@prometheus/utils';
import { BuildInfoDTO } from 'src/interfaces/BuildInfo';

export const getModules = () => {
  return api.get('/modules');
};

export const getInfo = (): Promise<BuildInfoDTO> => {
  return actuator.get('/actuator/info');
};
